import logoImg from "assets/logo.png";
import { clsx } from "clsx";
import type { HTMLAttributes } from "react";

export function Logo({ className, ...restProps }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx("brand-logo", className)} {...restProps}>
      <img src={logoImg} alt="monte carlo logo" className="h-full scale-[1.2] object-cover" />
    </div>
  );
}
